<script>
    export default {
        
    }
</script>

<template>
    <div class="list-item-link is-flex has-mask skeleton">
        <picture class="list-item-image list-item-image--fallback has-mask">
            <img src="/svg/one-planet.svg" alt="One Planet" loading="lazy">
        </picture>
        <div class="list-item-content is-flex-grow-1">
            <h2 class="title is-4 list-item-title">
                <progress class="progress is-large" max="100"></progress>
            </h2>
            <div class="list-item-subtitle is-size-7 mb-2">
                <progress class="progress is-medium mb-2" max="100"></progress>
                <progress class="progress is-medium" max="100"></progress>
            </div>
            <span class="button is-light is-rounded is-small">
                <span>.... ....</span>
                <span class="icon"><img src="/svg/chevron-right.svg" width="9" height="15" alt="chevron right" loading="lazy"></span>
            </span>
        </div>
    </div>
</template>
